import React, { useEffect, useMemo, useState } from "react";
import { apiFetch } from "../lib/api.js";

// Výběr klienta s hledáním. Vrací přes onPick celý objekt klienta
// ({ notion_id, klient_name, stav, lokalita, ... }). Sdílené trenérským i manažerským
// rozhraním (zakládání/editace úkolu), ať je zadání klienta všude stejné.
export default function KlientPicker({ currentName, onPick, onCancel }) {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState("");

  useEffect(() => {
    let cancel = false;
    (async () => {
      try {
        const r = await apiFetch("/api/clients?light=ids", { credentials: "include" });
        const j = await r.json();
        if (!cancel) setList(j.clients || []);
      } catch (e) {
        if (!cancel) setList([]);
      } finally {
        if (!cancel) setLoading(false);
      }
    })();
    return () => { cancel = true; };
  }, []);

  // `klient` je fallback pro tvar plne odpovedi /api/clients — ta se sem 10.8.2026
  // vracela z cache misto light=ids a `c.klient_name` bylo undefined. Backend je
  // opraveny, tohle je pojistka: bez ni tenhle picker rovnou spadl na
  // `c.klient_name.split(...)` (TypeError = bila obrazovka).
  const jmenoKlienta = (c) => String((c && (c.klient_name || c.klient)) || "").trim();

  const filtered = useMemo(() => {
    const query = q.trim().toLowerCase();
    const sJmenem = list.filter((c) => jmenoKlienta(c));
    if (!query) return sJmenem.slice(0, 30);
    return sJmenem
      .filter((c) => jmenoKlienta(c).toLowerCase().includes(query))
      .slice(0, 30);
  }, [list, q]);

  return (
    <div className="bg-white border border-slate-300 rounded-xl p-2">
      <input
        type="text"
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder="Hledat klienta…"
        autoFocus
        className="field w-full mb-2"
      />
      <div className="max-h-48 overflow-y-auto space-y-0.5">
        {loading && <div className="text-xs text-slate-400 italic p-2 text-center">Načítám klienty…</div>}
        {!loading && filtered.length === 0 && <div className="text-xs text-slate-400 italic p-2 text-center">Žádný klient.</div>}
        {!loading && filtered.map((c) => (
          <button
            key={c.notion_id || jmenoKlienta(c)}
            onClick={() => onPick(c)}
            className="w-full text-left text-sm px-2 py-1.5 rounded hover:bg-brand-50 flex items-center gap-2"
          >
            <div className="w-6 h-6 rounded-full bg-rose-100 text-rose-800 flex items-center justify-center text-[11px] font-bold flex-shrink-0">
              {jmenoKlienta(c).split(" ").slice(0, 2).map((p) => p[0]).join("").toUpperCase()}
            </div>
            <span className="flex-1 truncate">{jmenoKlienta(c)}</span>
            {c.stav && c.stav !== "Aktivní" && <span className="text-[11px] text-slate-400">{c.stav}</span>}
          </button>
        ))}
      </div>
      {currentName && onCancel && (
        <button onClick={onCancel} className="text-xs text-slate-500 hover:text-slate-800 mt-1.5 px-2 py-1">Zrušit</button>
      )}
    </div>
  );
}
